export default "__VITE_ASSET__DKsgUHV2__"